/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';

/**
 * ContributionAdjustmentsPreview Component
 * @returns {JSX.Element}
 * @constructor
 */
export function ContributionPreview() {
  const { t } = useTranslation();
  const {
    values: { rateBundleTerm },
  } = useFormikContext();

  return (
    <>
      {rateBundleTerm.priceAdjustmentRules.length > 0 ? (
        <Grid container mt={4}>
          <Grid item xs={12}>
            <Typography
              sx={{
                fontWeight: 'bold',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                color: '#49ad33',
              }}
            >
              {t('contributionPreviewHeader')}
            </Typography>
            <Box mt={2}>
              {rateBundleTerm.priceAdjustmentRules.map((rule) => (
                <Box key={rule.type}>{rule.defaultDescription}</Box>
              ))}
            </Box>
          </Grid>
        </Grid>
      ) : null}
    </>
  );
}
